import React, { useState } from "react";
import { Modal } from "antd";
import "./Modal.css";
import DownloadOnGooglePlay from "./DownloadOnGooglePlay";
import DownloadOnAppStore from "./DownloadOnAppStore";
import { useTranslation } from "react-i18next";
const DownloadButton = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <div className="download-button">
      <button onClick={showModal} className="nav-download">
        {" "}
        {t("Download")}
      </button>
      <Modal
        className="download-button-modal"
        footer={null}
        open={isModalOpen}
        onCancel={handleCancel}
      >
        <div className="download-modal-details">
          <h4>
            {t("Download")} Sportrex Gamers Wallet {t("and")} {t("earn")}{" "}
            {t("free")} <span>SPT Token</span>
          </h4>
          <div className="download-buttons">
            <DownloadOnGooglePlay />
            <DownloadOnAppStore />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DownloadButton;
